import { ContentBlock } from "@/types";
import { createSecurityServiceContent } from "@/content/services/service-content-helpers";

export const content: ContentBlock[] = [
  ...createSecurityServiceContent({
    serviceName: "data infrastructure and security cabling",
    summary:
      "Reliable security systems depend on tidy cabling and sensible infrastructure. Ozy Wide Group plans cable runs, device positions and future access so cameras, alarms, intercoms and access-control systems are easier to maintain.",
    suitedTo: [
      "new fitouts",
      "security upgrades",
      "warehouses",
      "offices",
      "retail premises",
      "multi-device security systems",
    ],
    includes: [
      "CCTV cabling",
      "alarm cabling",
      "access-control cabling",
      "intercom cabling",
      "device rough-in and infrastructure planning",
    ],
    notes: [
      "ceiling access",
      "wall cavities",
      "network location",
      "future expansion",
      "labelling",
      "power and data separation",
    ],
    process: [
      "Confirm the devices that need cabling and where the control or network equipment will sit.",
      "Plan cable paths that are practical for installation, maintenance and future changes.",
      "Label and test the work in line with the agreed security system scope.",
    ],
    faq: [
      "Security cabling is easiest to plan before walls, ceilings or shopfit-out finishes are closed.",
      "Good labelling helps future maintenance, troubleshooting and upgrades.",
      "Cabling paths may need to account for access, fire separation, weather exposure and equipment locations.",
    ],
  }),
];
